export const SETUP_PATH = '/tenant-setup';
export const TENANTS_PATH = '/tenants';
export const TENANT_SETUP_TENANT_DETAILS_PATH = `${SETUP_PATH}/tenant-details`;
export const TENANT_SETUP_DRIVERS_PATH = `${SETUP_PATH}/tenant-drivers`;
export const TENANT_SETUP_UTILITIES_PATH = `${SETUP_PATH}/tenant-utilities`;
export const TENANT_SETUP_LABELS_PATH = `${SETUP_PATH}/tenant-labels`;
export const TENANT_SETUP_SETTINGS_PATH = `${SETUP_PATH}/tenant-settings`;

export const addTenantRouteParam = (path) => `${TENANTS_PATH}/:tenant${path}`;
